var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarwin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 489 475.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#New_Gradient_Swatch_1);}.cls-2{fill:url(#New_Gradient_Swatch_1-2);}.cls-3{fill:url(#New_Gradient_Swatch_1-3);}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-11);}.cls-15{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 136.19,
    y1: 186.76,
    x2: 500.49,
    y2: 186.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878bb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465064"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 204.98,
    y1: 186.69,
    x2: 435.49,
    y2: 186.69,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: 237.66,
    y1: 186.78,
    x2: 369.98,
    y2: 186.78,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 194.91,
    y1: 83.03,
    x2: 284.8,
    y2: 83.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e39e8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d79aa4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 125.47,
    y1: 290.35,
    x2: 190.95,
    y2: 290.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 77.95,
    y1: 343.72,
    x2: 119.67,
    y2: 343.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 215.89,
    y1: 135.02,
    x2: 258.52,
    y2: 135.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 184.49,
    y1: 238.56,
    x2: 225.69,
    y2: 238.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 150.89,
    y1: 29.61,
    x2: 191.68,
    y2: 29.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 42.08,
    y1: 492.66,
    x2: 42.08,
    y2: 417.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#868ab2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475166"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 131.7,
    y1: 492.66,
    x2: 131.7,
    y2: 417.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 303.09,
    y1: 492.66,
    x2: 303.09,
    y2: 417.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 384.02,
    y1: 492.66,
    x2: 384.02,
    y2: 417.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 454.03,
    y1: 492.66,
    x2: 454.03,
    y2: 417.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 207.9,
    y1: 492.66,
    x2: 207.9,
    y2: 417.14,
    xlinkHref: "#linear-gradient-7"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "darwin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.22,356.06q-59.84,0-119.65,0a35.66,35.66,0,0,1-8.46-.8c-6.12-1.54-9.22-6.12-8.9-12,.34-6.26,4.07-10.6,10.64-11.52a62.13,62.13,0,0,1,8.53-.14q114.21,0,228.43.08c5.59,0,8.65-1.59,11.5-6.59q37.28-65.43,75.28-130.44c3.26-5.57,3.62-9.62.26-15.35q-38.42-65.69-76.12-131.77c-2.34-4.09-4.84-5.66-9.71-5.62q-78.86.61-157.72.64c-3.48,0-7.78-.71-10.13-2.3-4.52-3-5.55-8.58-4.9-12.46.59-3.45,4.79-8.43,9.1-9a39.19,39.19,0,0,1,6.09-.47c54.9-.27,109.81-.35,164.71-.95,9.49-.1,15.21,3.15,19.91,11.4q42.26,74.22,85.32,148c4.15,7.13,4.1,13.06,0,20.17Q454.2,271,411.66,345.49c-4.41,7.74-10,10.75-18.79,10.69C353,355.9,313.1,356.06,273.22,356.06Z",
    transform: "translate(-11.49 -17.34)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.45,302.64q-33.78,0-67.56,0a35.76,35.76,0,0,1-8.49-.55c-6-1.46-9.46-5.54-9.42-11.69.05-6.51,3.83-10.58,10.12-12,2.22-.5,4.64-.23,7-.23,42.45,0,84.91-.16,127.36.05,5.62,0,8.71-1.64,11.52-6.66,14.92-26.62,30.21-53,45.6-79.39,2.24-3.83,2.48-6.69.19-10.6-15.92-27.24-31.52-54.68-47.56-81.85-1.31-2.22-5.1-4.09-7.8-4.18-13.45-.44-26.92-.16-40.38-.26-9.27-.07-14.86-4.77-14.87-12.25,0-7.32,5.77-12.23,15-12.29,16.82-.11,33.65,0,50.48,0,6.27,0,10.72,2.54,13.89,8.08q28.57,49.81,57.45,99.44c3.52,6.05,3.37,11.38-.16,17.42q-28.56,48.91-56.65,98.12c-3.66,6.4-8.55,9-15.77,9C337.05,302.52,313.75,302.64,290.45,302.64Z",
    transform: "translate(-11.49 -17.34)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.42,250.66c-12.68,0-25.35.09-38,0-8.53-.08-13.84-5-13.73-12.41.1-6.88,5.33-11.81,13.6-11.89q31.82-.3,63.64,0c4.93.05,8.05-1.25,10.5-5.88,5.18-9.83,11.29-19.16,16.43-29a11.21,11.21,0,0,0,.13-9c-5.51-10.52-11.5-20.82-17.8-30.89a10.42,10.42,0,0,0-7.18-4.17c-8.51-.52-17.07-.13-25.61-.22-9.14-.11-15-4.84-15.11-12.08S281.77,123,291,122.94c12.16-.08,24.32.12,36.48-.1,5.85-.11,9.83,2.28,12.67,7.22,9.54,16.58,19.51,32.93,28.45,49.82,1.92,3.63,1.85,10-.08,13.67-8.93,16.91-18.87,33.28-28.36,49.89-3,5.3-7.43,7.39-13.46,7.29C314.26,250.53,301.84,250.67,289.42,250.66Z",
    transform: "translate(-11.49 -17.34)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.25,95.08c-10.6,0-21.2.13-31.8,0-8.36-.13-13.47-4.72-13.54-11.74s4.92-12.15,13.14-12.23q32.19-.31,64.37,0c7.5.08,12.54,5.49,12.38,12.15S279.66,94.87,272,95C261.45,95.22,250.85,95.07,240.25,95.08Z",
    transform: "translate(-11.49 -17.34)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M157.84,302.24c-6.71,0-13.43.22-20.13-.06-7.36-.31-12.05-4.9-12.23-11.39-.2-6.94,4.56-12.12,12.1-12.25q20.5-.36,41,0c7.58.14,12.46,5.28,12.34,12.1-.11,6.39-4.94,11.16-12.2,11.45-7,.28-13.94.06-20.91.06Z",
    transform: "translate(-11.49 -17.34)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.2,331.83c3.1,0,6.22-.22,9.3,0,6.59.56,11.16,5.28,11.17,11.63,0,6.64-3.52,11.07-10,11.68a114.2,114.2,0,0,1-21.64,0C81.58,354.57,78,350.24,78,343.53c0-6.27,4.55-11.08,11.17-11.65C92.45,331.59,95.83,331.83,99.2,331.83Z",
    transform: "translate(-11.49 -17.34)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M236.7,147.13a69.37,69.37,0,0,1-10.81-.64c-6.42-1-10.06-5.09-10-11.73s3.85-10.86,10.27-11.42a135.11,135.11,0,0,1,22.4,0c6.11.51,9.64,4.73,9.94,10.93s-2.68,10.61-8.73,12c-4.22.94-8.7.68-13.07.95C236.7,147,236.71,147.31,236.7,147.13Z",
    transform: "translate(-11.49 -17.34)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M205,250.39a93.17,93.17,0,0,1-10-.06,11.46,11.46,0,0,1-10.47-12.16c.25-6.64,4-10.69,10.46-11.19A134.32,134.32,0,0,1,215,227a11.52,11.52,0,0,1,10.67,12c-.15,6-4.9,10.87-11.42,11.4-3.07.25-6.18,0-9.27,0Z",
    transform: "translate(-11.49 -17.34)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M171.36,41.47a92.8,92.8,0,0,1-9.29,0c-6.77-.69-11.32-5.41-11.17-11.66.16-6.67,4-10.83,10.38-11.52A109.16,109.16,0,0,1,181.41,18c6.8.54,10.74,5.68,10.22,12.26s-4.51,10.23-11,10.94a87.57,87.57,0,0,1-9.31,0Z",
    transform: "translate(-11.49 -17.34)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M72.67,454.56A45.74,45.74,0,0,1,71,467a33.88,33.88,0,0,1-4.94,10.47,32.68,32.68,0,0,1-8.24,8,38.81,38.81,0,0,1-11.54,5.25,46.45,46.45,0,0,1-8.18,1.5q-4.41.42-9.54.42H11.49V417.14H28.76q5.13,0,9.54.43a46.47,46.47,0,0,1,8.18,1.49A39.76,39.76,0,0,1,58,424.25a31.7,31.7,0,0,1,8.18,7.88,32.64,32.64,0,0,1,4.86,10.21A44.74,44.74,0,0,1,72.67,454.56Zm-9.15,0q0-10.89-4.8-17.66a25.71,25.71,0,0,0-13.78-9.6,38.25,38.25,0,0,0-7.67-1.47q-4.23-.39-9.55-.39h-7v58.92h7q5.33,0,9.55-.39a37.56,37.56,0,0,0,7.67-1.47,25.17,25.17,0,0,0,13.78-9.88Q63.52,465.57,63.52,454.56Z",
    transform: "translate(-11.49 -17.34)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M135.67,417.14h-7.95L97,492.66h9.87l9-22.75,6.11-15.4q4.59-11.53,9.65-25.63h.23q4.82,13.9,9.46,25.63l6.13,15.4,9,22.75h10Z",
    transform: "translate(-11.49 -17.34)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M303,429.62q-.9,5.19-4.22,18.17l-11.7,44.87h-9.34l-23.14-75.52h9.2l13,44.31q3.1,10.67,5.28,19.19h.22q1.13-5.25,2.45-10.22c.88-3.31,1.65-6.26,2.33-8.86l11.45-44.42h9.2l11.4,44.42q4.19,16,4.75,19.08h.23q1.95-7.9,5.29-19.19l13-44.31h9.2l-23.16,75.52h-9.33l-11.65-44.87q-3.19-12.53-4.21-18.17Z",
    transform: "translate(-11.49 -17.34)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M379.42,492.66V417.14h9.2v75.52Z",
    transform: "translate(-11.49 -17.34)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M462.12,459.25q6.94,10,13.72,20.54h.34q-.74-11-.74-22.46V417.14h9.26v75.52h-9.2l-29.63-42.11q-7.68-11-13.72-20.54h-.33q.72,10.33.73,24.1v38.55h-9.2V417.14h9.14Z",
    transform: "translate(-11.49 -17.34)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M230.77,492.66l-22.35-32.28v-.23a33.75,33.75,0,0,0,8.22-2.48,21.68,21.68,0,0,0,6.35-4.35,19,19,0,0,0,4.12-6.26,21.78,21.78,0,0,0,1.46-8.19A19.85,19.85,0,0,0,224.4,426q-4.17-5.18-12.06-7.31a38.89,38.89,0,0,0-6.35-1.16,83,83,0,0,0-8.42-.37H185l2.6,8.3h10q4.35,0,7.17.28a26.11,26.11,0,0,1,4.86.9,13.48,13.48,0,0,1,6.71,4.27,12.17,12.17,0,0,1,2.49,7.81,13,13,0,0,1-2.6,8.41,14.72,14.72,0,0,1-7.39,4.69,26.73,26.73,0,0,1-5.37,1q-3,.29-7.22.28h0l3,9.62,22.27,30Z",
    transform: "translate(-11.49 -17.34)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarwin);
export default __webpack_public_path__ + "static/media/darwin.12957b5c5245746c92b560cdf0a94fdd.svg";
export { ForwardRef as ReactComponent };